import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function OverlayLayout(props = {}, childrenComponents = []) {
	return {
		componentName: 'OverlayLayout',
		componentId: uuidv4(),
		props: _.merge(
			{
				placement: 'bottom',
				scrollBehavior: 'default',
				backdrop: 'none',
				showArrow: false,
				offsets: {
					skidding: 0,
					distance: 0,
				},
			},
			props,
		),
		childrenComponents,
	};
}
